import React, { createContext, useContext, useEffect, useState } from "react";

const AccessibilityContext = createContext();

export const AccessibilityProvider = ({ children }) => {
  const [fontScale, setFontScale] = useState(1); // 1x font size
  const [contrast, setContrast] = useState(100); // 100% = normal contrast
  const [brightness, setBrightness] = useState(1); // 1 = normal brightness

  // Reset all settings to defaults
  const resetAccessibility = () => {
    setFontScale(1);
    setContrast(100);
    setBrightness(1);
    localStorage.removeItem("a11y-settings");
  };

  // Load saved settings from localStorage
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("a11y-settings"));
    if (saved) {
      setFontScale(saved.fontScale ?? 1);
      setContrast(saved.contrast ?? 100);
      setBrightness(saved.brightness ?? 1);
    }
  }, []);

  // Save settings whenever they change
  useEffect(() => {
    localStorage.setItem(
      "a11y-settings",
      JSON.stringify({ fontScale, contrast, brightness })
    );
  }, [fontScale, contrast, brightness]);

  return (
    <AccessibilityContext.Provider
      value={{
        fontScale,
        setFontScale,
        contrast,
        setContrast,
        brightness,
        setBrightness,
        resetAccessibility,
      }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
};

// Custom hook to use accessibility context
export const useAccessibility = () => useContext(AccessibilityContext);
